import api from "./api";

const checkOffCode = async (code,classId,courseId, courseCategoryId,teacherId,amount) => await api.post(`offCode/${code}`,{
    classId,courseId, courseCategoryId,teacherId,amount
})

export default {checkOffCode}
